import './downloads.scss';
import appleLogoDesktop from '../../assets/apple-logo-desktop.svg';
import androidLogoDesktop from '../../assets/android-logo-desktop.svg';
import appleLogoTablet from '../../assets/apple-logo-tablet.svg';
import androidLogoTablet from '../../assets/android-logo-tablet.svg';
import appleLogoPhone from '../../assets/apple-logo-phone.svg';
import androidLogoPhone from '../../assets/android-logo-phone.svg';
import wellstarLogo from '../../assets/wellstar-top.svg';
import { openiPhoneLink, openAndroidLink, openiPadLink } from '../../links';
import { desktop, tablet, phone } from '../../consts';
import DownloadProperties from '../../types/downloadProperties';

const Downloads: React.FC<DownloadProperties> = props => {
    const { screen } = props;
    if (screen === phone) {
        return (
            <div className="download">
                <div className="title">
                    <img src={wellstarLogo} alt="Wellstar" />
                    <h3 className="overline">GET STARTED</h3>
                    <h1 className="landing">Download the Epic Haiku or Epic Canto App</h1>
                </div>
                <div className="features">
                    <div className="mobile-frame">
                        <div className="iphone">
                            <div className="device-frame">
                                <div className="device-frame-os">
                                    <img src={screen === desktop ? appleLogoDesktop : screen === tablet ? appleLogoTablet : appleLogoPhone} alt="iPhone" />
                                </div>
                                <h2 className="iphone-frame-title">iPhone</h2>
                                <button className="device-frame-button" onClick={openiPhoneLink}>
                                    Download
                                </button>
                            </div>
                        </div>
                        <div className="android">
                            <div className="device-frame">
                                <div className="device-frame-os">
                                    <img
                                        src={screen === desktop ? androidLogoDesktop : screen === tablet ? androidLogoTablet : androidLogoPhone}
                                        alt="Android"
                                    />
                                </div>
                                <h2 className="android-frame-title">Android</h2>
                                <button className="device-frame-button" onClick={openAndroidLink}>
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-frame">
                        <div className="ipad">
                            <div className="device-frame">
                                <div className="device-frame-os">
                                    <img src={screen === desktop ? appleLogoDesktop : screen === tablet ? appleLogoTablet : appleLogoPhone} alt="iPhone" />
                                </div>
                                <h2 className="ipad-frame-title">iPad</h2>
                                <button className="device-frame-button" onClick={openiPadLink}>
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="download">
            <div className="title">                
                <img src={wellstarLogo} alt="Wellstar" />
                <h3 className="overline">GET STARTED</h3>
                <h1 className="landing">Download the Epic Haiku or Epic Canto App</h1>
            </div>
            <div className="features">
                <div className="iphone">
                    <div className="device-frame">
                        <div className="device-frame-os">
                            <img src={screen === desktop ? appleLogoDesktop : screen === tablet ? appleLogoTablet : appleLogoPhone} alt="iPhone" />
                        </div>
                        <h2 className="iphone-frame-title">iPhone</h2>
                        <button className="device-frame-button" onClick={openiPhoneLink}>
                            Download
                        </button>
                    </div>
                </div>
                <div className="android">
                    <div className="device-frame">
                        <div className="device-frame-os">
                            <img src={screen === desktop ? androidLogoDesktop : screen === tablet ? androidLogoTablet : androidLogoPhone} alt="Android" />
                        </div>
                        <h2 className="android-frame-title">Android</h2>
                        <button className="device-frame-button" onClick={openAndroidLink}>
                            Download
                        </button>
                    </div>
                </div>
                <div className="ipad">
                    <div className="device-frame">
                        <div className="device-frame-os">
                            <img src={screen === desktop ? appleLogoDesktop : screen === tablet ? appleLogoTablet : appleLogoPhone} alt="iPhone" />
                        </div>
                        <h2 className="ipad-frame-title">iPad</h2>
                        <button className="device-frame-button" onClick={openiPadLink}>
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Downloads;
